import React, { useState, useEffect, useCallback } from "react";
import DesktopView from "../layout/DesktopView";
import TrainingDataCard from "./TrainingDataCard";
import TrainingDataEditor from "./TrainingDataEditor";
import { modelService } from "../../services/modelService";
import { useToast } from "../common/ToastContext";

const TrainingDataDesktop = () => {
  const [trainingData, setTrainingData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const { showToast } = useToast();

  const fetchTrainingData = useCallback(async () => {
    try {
      const response = await modelService.getTrainingDataList();
      const sortedData = response.sort((a, b) => a.name.localeCompare(b.name));
      setTrainingData(sortedData);
    } catch (error) {
      console.error("Error fetching training data:", error);
      showToast("Failed to fetch training data", "error");
    }
  }, [showToast]);

  useEffect(() => {
    fetchTrainingData();
  }, [fetchTrainingData]);

  const handleSearch = (term) => {
    // Search is handled internally by DesktopView
  };

  const handleTrainingDataClick = async (data) => {
    try {
      const fullData = await modelService.getTrainingDataById(data.id);
      setSelectedItem(fullData);
      setIsEditorOpen(true);
    } catch (error) {
      console.error("Error fetching full training data:", error);
      showToast("Failed to fetch training data details", "error");
    }
  };

  const handleSaveTrainingData = async (dataToSave) => {
    try {
      if (dataToSave.id) {
        await modelService.updateTrainingData(dataToSave.id, dataToSave);
      } else {
        await modelService.createTrainingData(dataToSave);
      }
      await fetchTrainingData(); // Fetch updated data
      setIsEditorOpen(false);
      showToast("Training data saved successfully", "success");
    } catch (error) {
      console.error("Error saving training data:", error);
      showToast("Failed to save training data", "error");
    }
  };

  const handleDeleteTrainingData = async (dataId) => {
    try {
      await modelService.deleteTrainingData(dataId);
      await fetchTrainingData();
      setIsEditorOpen(false);
      showToast("Training data deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting training data:", error);
      showToast("Failed to delete training data", "error");
    }
  };

  const handleAddNewTrainingData = () => {
    setSelectedItem(null);
    setIsEditorOpen(true);
  };

  const handleCloseEditor = () => {
    setIsEditorOpen(false);
    setSelectedItem(null);
  };

  return (
    <>
      <DesktopView
        items={trainingData}
        selectedItem={selectedItem}
        onSearch={handleSearch}
        searchPlaceholder="Filter training data ..."
        contextMenuItems={[]}
        onItemClick={handleTrainingDataClick}
        onSave={handleSaveTrainingData}
        onDelete={handleDeleteTrainingData}
        Card={TrainingDataCard}
        addNewItem={handleAddNewTrainingData}
        eventName="trainingDataCreated"
      />
      {isEditorOpen && (
        <TrainingDataEditor
          item={selectedItem}
          onSave={handleSaveTrainingData}
          onClose={handleCloseEditor}
          onDelete={handleDeleteTrainingData}
        />
      )}
    </>
  );
};

export default TrainingDataDesktop;
